export default "__VITE_ASSET__d4e6a0e4__"